const WORKOUTS_KEY = {
  ALL: 'all',
  BY_PROFILE_ID: 'byProfileId',
  BY_PLAN_ID: 'byPlanId',
  BY_WEEK: 'byWeek',
  BY_DAY: 'byDay',
  CURRENT: 'current',
  STARTED: 'started',
  SMART: 'smart',
  SUGGESTED: 'suggested',
  DATA: 'data',
  LOGGED: 'logged',
  NON_LOGGED: 'nonLogged',
  NON_LOGGED_AND_PLANNED: 'nonLoggedAndPlanned',
  PLANNED: 'planned',
  PREFERENCES: 'preferences',
  RECOMMENDED: 'recommended',
  DOWNLOADED: 'downloaded'
}

export default WORKOUTS_KEY
